import { useContext } from "react";
import { AgentContext } from "../context/AgentContext";

export const useAgentHook = () => {
  const context = useContext(AgentContext);

  return context;
};
